import { Grid, Box } from "@mui/material";
import { NO_RECORD_FOUND } from "../constants/Strings";
export default function NoDataFound() {
  return (
    <Box
      // display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
    >
      <Grid variant="h6" align="center" p={2} sx={{ backgroundColor: "rgba(255, 255, 255, 0.85)", borderRadius:"0 0 8px 8px"}}>
        {NO_RECORD_FOUND}
      </Grid>
    </Box>
  );
}
